import { render } from "./RejectOrder.vue?vue&type=template&id=661db898"
import script from "./RejectOrder.vue?vue&type=script&lang=js"
export * from "./RejectOrder.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__